// import { isEmptyObject } from '../core/util';

export const productTypesAnalytics = {
  DEFAULT: 'unidentified',
  MUTUAL_FUND: 'Mutual Fund',
  BROKERAGE: 'Brokerage',
  COLLEGE: '529',
  RPS_OCR: 'RPS OCR'
};

export const accountTypesAnalytics = {
  ROLLOVER: {
    DEFAULT: 'ROLLOVER_IRA',
    DIRECT: 'ROLLOVER_IRA_DIRECT',
    INDIRECT: 'ROLLOVER_IRA_INDIRECT',
    INTERNAL: 'ROLLOVER_IRA_INTERNAL',
    OCR_OMNI: 'ROLLOVER_IRA_OCR_OMNI',
    OCR_TRAC: 'ROLLOVER_IRA_OCR_TRAC',
    ROTH_ROLLOVER_OMNI: 'ROTH_ROLLOVER_OMNI',
    ROTH_ROLLOVER_TRAC: 'ROTH_ROLLOVER_TRAC'
  },
  TRANSFER: {
    DEFAULT: 'TRANSFER_IRA',
    ROLLOVER: 'TRANSFER_IRA_ROLLOVER',
    ROTH: 'TRANSFER_IRA_ROTH',
    SEP: 'TRANSFER_IRA_SEP',
    TRADITIONAL: 'TRANSFER_IRA_TRADITIONAL'
  },
  CONTRIBUTORY: {
    DEFAULT: 'CONTRIBUTORY_IRA',
    ROTH: 'CONTRIBUTORY_IRA_ROTH',
    TRADITIONAL: 'CONTRIBUTORY_IRA_TRADITIONAL'
  },
  TAXABLE: {
    DEFAULT: 'TAXABLE',
    SCHRODINGER: {
      DEFAULT: 'TAXABLE_INDIVIDUAL_JOINT',
      NEW: 'TAXABLE_INDIVIDUAL_JOINT_NEW',
      TRANSFER: 'TAXABLE_INDIVIDUAL_JOINT_TRANSFER'
    },
    INDIVIDUAL: {
      DEFAULT: 'TAXABLE_INDIVIDUAL',
      NEW: 'TAXABLE_INDIVIDUAL_NEW',
      TRANSFER: 'TAXABLE_INDIVIDUAL_TRANSFER'
    },
    JOINT: {
      DEFAULT: 'TAXABLE_INDIVIDUAL_JOINT',
      NEW: 'TAXABLE_INDIVIDUAL_JOINT_NEW',
      TRANSFER: 'TAXABLE_INDIVIDUAL_JOINT_TRANSFER'
    },
    UGMA: {
      DEFAULT: 'TAXABLE_UGMA-UTMA',
      NEW: 'TAXABLE_UGMA-UTMA_NEW',
      TRANSFER: 'TAXABLE_UGMA-UTMA_TRANSFER'
    },
    TRUST: {
      DEFAULT: 'TAXABLE_TRUST',
      NEW: 'TAXABLE_TRUST_NEW'
    }
  },
  TOD: {
    DEFAULT: 'TAXABLE_TOD',
    INDIVIDUAL: 'TAXABLE_INDIVIDUAL_NEW_TOD',
    JOINT: 'TAXABLE_INDIVIDUAL_JOINT_NEW_TOD'
  },
  TRUST: {
    DEFAULT: 'TRUST'
  },
  COLLEGE: {
    DEFAULT: '529',
    NATIONAL: {
      DEFAULT: '529_NATIONAL',
      NEW: '529_NATIONAL_NEW',
      TRANSFER: '529_NATIONAL_TRANSFER'
    },
    MARYLAND: {
      DEFAULT: '529_MARYLAND',
      NEW: '529_MARYLAND_NEW',
      TRANSFER: '529_MARYLAND_TRANSFER'
    },
    ALASKA: {
      DEFAULT: '529_ALASKA',
      NEW: '529_ALASKA_NEW',
      TRANSFER: '529_ALASKA_TRANSFER'
    }
  }
};

export const TODOrDefault = (beneficiaries, defaultAccountType) => {
  return beneficiaries &&
    (beneficiaries.individuals?.length > 0 ||
      beneficiaries.entities?.length > 0)
    ? accountTypesAnalytics.TOD[defaultAccountType]
    : accountTypesAnalytics.TAXABLE[defaultAccountType].NEW;
};

const getFONASUMFContributoryAccountAnalyticsType = toIRAAccountType =>
  accountTypesAnalytics.CONTRIBUTORY[toIRAAccountType];

const getFONASUMFTransferAccountAnalyticsType = fromIRAAccountType =>
  accountTypesAnalytics.TRANSFER[fromIRAAccountType];

export const getFONASUAnalyticsAccountType = store =>
  ({
    ROLLOVER_IRA: accountTypesAnalytics.ROLLOVER.DEFAULT,
    CONTRIBUTORY_IRA: getFONASUMFContributoryAccountAnalyticsType(
      store?.app?.toIRAAccountType
    ),
    TRANSFER_IRA: getFONASUMFTransferAccountAnalyticsType(
      store?.app?.fromIRAAccountType
    ),
    INDIVIDUAL: accountTypesAnalytics.TAXABLE.INDIVIDUAL.DEFAULT,
    JOINT_TENANT: accountTypesAnalytics.TAXABLE.JOINT.DEFAULT,
    UGMA_UTMA: accountTypesAnalytics.TAXABLE.UGMA.DEFAULT
  }[store?.accountType]);
